import React from "react"
import { useHistory } from "react-router-dom"
import styled from "styled-components"
import devices from "styles/devices"
import { Button, ButtonType } from "components/atoms/Button"
import { Card } from "components/atoms/Card"
import Typography from "components/_blueprint/Typography/Typography"
import ConveyancingImage from "url:assets/images/offer-accepted-status/conveyancing.png"

interface ConveyancingCardProps {
  friendlyId: string
  onViewQuotes?: () => void
}

const ConveyancingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 5px;

  @media screen and ${devices.bp_sm} {
    flex-direction: row;
  }
`

const ConveyancingContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and ${devices.bp_sm} {
    width: 60%;
  }
`

const ConveyancingIllustration = styled.div`
  display: none;
  flex: 1;
  background-image: url(${ConveyancingImage});
  background-size: cover;
  background-position: center;
  min-height: 240px;
  border-radius: 16px;

  @media screen and ${devices.bp_sm} {
    display: block;
  }
`

const ConveyancingIllustrationMobile = styled(ConveyancingIllustration)`
  display: flex;
  width: 100%;

  @media screen and ${devices.bp_sm} {
    display: none;
  }
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const StyledConveyancingCard = styled(Card)`
  border-radius: 24px;
`

export const ConveyancingCardComponent: React.FC<ConveyancingCardProps> = ({
  friendlyId,
  onViewQuotes,
}) => {
  const history = useHistory()

  const handleViewQuotes = () => {
    if (onViewQuotes) {
      onViewQuotes()
    } else {
      history.push(`/application/${friendlyId}/conveyancing`)
    }
  }

  return (
    <StyledConveyancingCard
      theme="default"
      content={
        <ConveyancingContainer>
          <ConveyancingIllustrationMobile />
          <ConveyancingContent>
            <TextContent>
              <Typography.H4>Secure your property's legal work</Typography.H4>
              <Typography.Body color="secondary" margin="0">
                Conveyancing is a vital part of securing your property. It's important to instruct
                your chosen solicitor as soon as you're ready. Your Mortgage Expert has provided a
                number of quotes for you to compare and review.
              </Typography.Body>
            </TextContent>
            <Button
              type={ButtonType.Solid}
              text="View conveyancing quotes"
              onClick={handleViewQuotes}
            />
          </ConveyancingContent>
          <ConveyancingIllustration />
        </ConveyancingContainer>
      }
    />
  )
}
